import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import UITextField from "@/components/ui-controls/textfield";
import GetIcon from "@/components/font-awesome-icon";

const DynamicFieldWrapper = ({ form, title = "", fieldKey = "" }) => {
  const addField = () => {
    form.setFieldValue(fieldKey, [...form.values[fieldKey], ""]);
  };

  const onFieldChange = (index, value) => {
    const updatedFields = [...form.values[fieldKey]];
    updatedFields[index] = { value: value };
    form.setFieldValue(fieldKey, updatedFields);
  };

  const deleteField = (index) => {
    const updatedFields = [...form.values[fieldKey]];
    updatedFields.splice(index, 1);
    form.setFieldValue(fieldKey, updatedFields);
  };

  // const editField = (index, newValue) => {
  //   const updatedFields = [...form.values[fieldKey]];
  //   updatedFields[index] = { value: newValue };
  //   form.setFieldValue(fieldKey, updatedFields);
  // };

  const getError = (index) => {
    return (
      (form.touched[fieldKey] &&
        form.touched[fieldKey][index] &&
        form.errors[fieldKey] &&
        form.errors[fieldKey][index]) ||
      false
    );
  };
  return (
    <div>
      {form.values[fieldKey].map((field, index) => (
        <Box key={index} sx={{ mb: 3 }}>
          <UITextField
            type={"text"}
            name={fieldKey}
            value={field.value}
            title={title}
            placeholder={title}
            onChange={(e) => onFieldChange(index, e.target.value)}
            postfix={
              form.values[fieldKey].length > 1 && (
                <GetIcon icon={faTrash} onClick={() => deleteField(index)} />
              )
            }
            // onBlur={handleBlur}
            error={getError(index)}
            // disabled={disableFields}
          />
        </Box>
      ))}

      <Typography
        variant="body2"
        sx={{ cursor: "pointer", color: "#0043CE", display: "inline-block" }}
        onClick={addField}
      >
        + add one more
      </Typography>
    </div>
  );
};

export default DynamicFieldWrapper;
